import z from "zod";

export const axiosErrorSchema = z.object({
  response: z.object({
    data: z.object({
      error: z.object({
        code: z.string(),
      }),
    }),
  }),
});
